import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export interface ApiAccessRequestStatus {
  id: number;
  userId: number;
  status: string;
  requestedAt: string;
  reviewedAt: string | null;
  reviewedBy: number | null;
  userName: string | null;
  email: string | null;
  phoneNumber: string | null;
}

export const getApiAccessRequestStatus = async (
  token: string,
  t: (key: string) => string
): Promise<ApiAccessRequestStatus> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/User/GetApiAccessRequestStatus`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch API access request status");
    }

    const data: ApiAccessRequestStatus = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};